import React, { useEffect, useState } from 'react';
import { Collapse } from '@mui/material';
import CardBasic from 'screens/shared/card-basic';
import { useSelector } from 'react-redux';
import { explorerObj, _t } from 'utils';
import Icon from 'screens/shared/icon';
import Util from 'screens/shared/utilities';
import TextField from './input-field';

export default ({
  onChange,
  error = '',
  value = '',
  helpText = '',

  isCollapsed = true,
  isMultiple = false,

  isFilter = false,
  filterByPropName = 'properties.name',
  title = '',
  subTitle = '',

  setItemTitle,
  setItemDetails,
  itemIcon = '',
  itemIconColor = 'var(--color-base)',
  setItemIconText,

  valuePropName = 'id',
  returnValuePropOnly = true,

  getItemsStoreMap,
  items = [],
}) => {
  const store = useSelector(getItemsStoreMap || ((e) => e));
  const [filter, setFilter] = useState('');
  const [exclusiveItem, setExclusiveItem] = useState('');
  const [collapsed, toggleCollapsed] = useState(isCollapsed);

  useEffect(() => {
    toggleCollapsed(isCollapsed);
  }, [isCollapsed]);

  useEffect(() => {
    const current = items.find((item) => item[valuePropName] === value?.[0]);
    if (!exclusiveItem && value.length > 0 && current?.exclusive) {
      setExclusiveItem(current[valuePropName]);
    } else if (exclusiveItem && ((!isMultiple ? !value : value.length === 0) || value.length > 1)) {
      setExclusiveItem('');
    }
    // eslint-disable-next-line
  }, [value]);

  const cls = 'background-base-light border-base';
  const disabledClass = ' disabled-item';
  const onSelectExclusive = (e) => {
    if (onChange) {
      onChange(returnValuePropOnly ? (isMultiple ? [e[valuePropName]] : e[valuePropName]) : e);
    }
    setExclusiveItem(e[valuePropName]);
  };
  const isSelected = (e) => (Array.isArray(value) ? (value.includes(e[valuePropName]) ? cls : '') : (value === e[valuePropName] ? cls : ''));
  const selectHandler = (e) => {
    if (e.exclusive) {
      return onSelectExclusive(e);
    }
    if (onChange) {
      onChange(returnValuePropOnly ? (isMultiple ? [...value, e[valuePropName]] : e[valuePropName]) : e);
    }
    if (!isMultiple) {
      toggleCollapsed(true);
    }
    return true;
  };
  const deSelectHandler = (e) => {
    if (onChange) {
      onChange([...(value || []).filter((valueInner) => valueInner !== e[valuePropName])]);
    }
    if (exclusiveItem && exclusiveItem === e[valuePropName]) {
      setExclusiveItem('');
    }
  };

  if (getItemsStoreMap) items = store;
  if (isFilter && filterByPropName && filter) items = items.filter((e) => explorerObj(e, filterByPropName).toLowerCase().includes(filter.toLowerCase()));

  return (
    <>
      <div className={`border-gray common-selector border-radius-4 ${error ? 'border-danger' : ''}`}>
        <div className="pointer p-12 p-l-8 p-r-8" onClick={() => toggleCollapsed(!collapsed)}>
          {(value && !isMultiple) ? setItemTitle(items.find((item) => item[valuePropName] === value)) : title}
          <Icon name="sort" className="float-right" />
        </div>
        <Collapse in={!collapsed} collapsedSize="0px">
          {!!subTitle && <span className="block color-dark m-l-12 font-14">{subTitle}</span>}
          {isFilter && <TextField className="block m-12 relative top-5" label={_t('Search')} value={filter} onChange={(e) => setFilter(e)} />}
          {!collapsed && (
            <div className="cards p-12 p-t-4 min-height-220 max-height-220 scroll">
              {items?.map((e, i) => (
                <CardBasic
                  key={e[valuePropName] || i}
                  onClick={() => (isMultiple && isSelected(e) ? deSelectHandler(e) : selectHandler(e))}
                  isArrow={false}
                  title={setItemTitle ? setItemTitle(e) : ''}
                  details={setItemDetails ? setItemDetails(e) : ''}
                  icon={itemIcon}
                  iconText={setItemIconText ? setItemIconText(e) : ''}
                  iconFill={itemIconColor}
                  className={isSelected(e) + (exclusiveItem && exclusiveItem !== e[valuePropName] ? disabledClass : '')}
                />
              ))}
              {!items?.length && <Util.NoData />}
            </div>
          )}
        </Collapse>
      </div>

      {(helpText) && <span className="block color-dark font-13 m-t-4- m-b-12">{helpText}</span>}
      {error && <span className="block color-danger font-13 m-t-4- m-b-12">{error}</span>}
    </>
  );
};
